import { FONT_SIZE_ADJUSTMENT, ADJUSTMENT_THRESHOLDS } from 'constants/wordcloud';

/**
 * Calculates adjusted maximum font size based on word distribution and canvas dimensions
 *
 * @param {Object} params - Parameters for font size adjustment
 * @param {Array} params.words - Array of word objects with text, value, and versions
 * @param {number} params.originalMaxPx - Original maximum pixel size
 * @param {number} params.minPx - Minimum pixel size
 * @param {number} params.width - Canvas width
 * @param {number} params.height - Canvas height
 * @returns {number} Adjusted maximum pixel size
 */
export const calculateAdjustedFontSize = ({ words, originalMaxPx, minPx, width, height }) => {
  const maxWeight = Math.max(...words.map((w) => w.value));
  const wordsWithMaxValue = words.filter((w) => w.value === maxWeight).length;
  const totalWords = words.length;
  const highValueRatio = wordsWithMaxValue / totalWords;

  let adjustedMaxPx = originalMaxPx;

  if (highValueRatio > ADJUSTMENT_THRESHOLDS.HIGH_VALUE_RATIO && totalWords > ADJUSTMENT_THRESHOLDS.MIN_WORDS_COUNT) {
    // Calculate estimated space needed vs available space
    const canvasArea = width * height;
    const estimatedWordArea =
      wordsWithMaxValue * (adjustedMaxPx * adjustedMaxPx * FONT_SIZE_ADJUSTMENT.WORD_AREA_FACTOR);

    // If estimated area exceeds maximum% of canvas, reduce font size
    while (
      estimatedWordArea > canvasArea * ADJUSTMENT_THRESHOLDS.MAX_CANVAS_COVERAGE &&
      adjustedMaxPx > minPx + FONT_SIZE_ADJUSTMENT.MIN_MARGIN
    ) {
      adjustedMaxPx -= Math.floor(adjustedMaxPx * FONT_SIZE_ADJUSTMENT.FONT_DECREASE_FACTOR);

      const newEstimatedArea =
        wordsWithMaxValue * (adjustedMaxPx * adjustedMaxPx * FONT_SIZE_ADJUSTMENT.WORD_AREA_FACTOR);

      if (newEstimatedArea <= canvasArea * ADJUSTMENT_THRESHOLDS.MAX_CANVAS_COVERAGE) {
        break;
      }
    }
  }

  return adjustedMaxPx;
};
